import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const datesApi = createApi({
  reducerPath: 'datesApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  tagTypes: ['WorkshopDates', 'MyDates'],
  endpoints: (builder) => ({
    getDates: builder.query({
      query: (id) => ({
        url: urls.foDates(id),
      }),
      providesTags: ['WorkshopDates'],
    }),
    getEventDates: builder.query({
      query: (id) => ({
        url: urls.foEventDates(id),
      }),
      providesTags: ['WorkshopDates'],
    }),
    getDate: builder.query({
      query: (id) => ({
        url: urls.foDateDetail(id),
        method: 'GET',
      }),
    }),
    getDateParticipants: builder.query({
      query: (id) => ({
        url: urls.foDateParticipants(id),
        method: 'GET',
      }),
    }),
    getAllDates: builder.query({
      query: () => ({
        url: urls.foAllDates,
      }),
    }),
    getMyDates: builder.query({
      query: () => ({
        url: urls.foMyDates,
        method: 'GET',
      }),
      providesTags: ['MyDates'],
    }),
    signIntoDate: builder.mutation({
      query({ dateId, action }) {
        const formData = {
          date_id: dateId,
          action: action,
        };
        return {
          url: urls.foRegistration,
          data: formData,
          method: 'POST',
        };
      },
      invalidatesTags: ['WorkshopDates', 'MyDates'],
    }),
    toggleDateEnabled: builder.mutation({
      query(id) {
        return {
          url: urls.foDateToggleEnabled(id),
          method: 'POST',
        };
      },
      invalidatesTags: ['WorkshopDates', 'MyDates'],
    }),
    saveDate: builder.mutation({
      query({ dateId, workshopId, data }) {
        const formData = {
          fo_workshop_id: Number(workshopId),
          description: data.description,
          name: data.name,
          location: data.location,
          date_from: data.date_from,
          date_to: data.date_to,
          capacity: data.capacity,
          lecturer_id: data.lecturer_id,
          creator_id: data.creator_id,
        };
        if (dateId) {
          return {
            url: urls.foDateDetail(dateId),
            method: 'PATCH',
            data: formData,
          };
        } else {
          return {
            url: urls.foDatesStore,
            method: 'POST',
            data: formData,
          };
        }
      },
    }),
    deleteDate: builder.mutation({
      query(id) {
        return {
          url: urls.foDateDetail(id),
          method: 'DELETE',
        };
      },
    }),
    getCollidedDates: builder.mutation({
      query: (data) => {
        return {
          url: urls.foDatesCollisions,
          data: data,
          method: 'POST',
        };
      },
    }),
    getMyCollidedDates: builder.mutation({
      query: (data) => {
        return {
          url: urls.foMyDatesCollisions,
          data: data,
          method: 'POST',
        };
      },
    }),
  }),
});

export const {
  useGetDatesQuery,
  useGetEventDatesQuery,
  useGetDateQuery,
  useGetDateParticipantsQuery,
  useGetAllDatesQuery,
  useGetMyDatesQuery,
  useSaveDateMutation,
  useDeleteDateMutation,
  useSignIntoDateMutation,
  useToggleDateEnabledMutation,
  useGetCollidedDatesMutation,
  useGetMyCollidedDatesMutation,
} = datesApi;
